module.exports = __webpack_public_path__ + "static/36575D_2_0-66a554e6fd7f6ed68f1d59164722d672.ttf";